document.addEventListener("DOMContentLoaded", function (event) {
  //truncated text blocks
  const texts = document.querySelectorAll(".aur-truncate-text");

  texts.forEach((text) => {
    const lineHeight = parseInt(getComputedStyle(text).lineHeight);
    const maxHeight = parseInt(getComputedStyle(text).maxHeight);
    const fullText = text.textContent.trim();
    if (text.scrollHeight > maxHeight) {
      let start = 0;
      let end = text.textContent.length - 1;
      let lastVisibleCharIndex = -1;

      while (start <= end) {
        const mid = Math.floor((start + end) / 2);
        text.textContent = text.textContent.substring(0, mid);
        if (text.scrollHeight <= maxHeight) {
          lastVisibleCharIndex = mid;
          start = mid + 1;
        } else {
          end = mid - 1;
        }
      }

      if (lastVisibleCharIndex !== -1) {
        const lastVisibleText = text.textContent
          .substring(0, lastVisibleCharIndex)
          .trim();
        text.textContent = lastVisibleText + "...";
        const seeMoreLink = text.nextElementSibling;
        const seeMoreLinkOpenText = seeMoreLink.getAttribute("data-open-text");
        const seeMoreLinkClosedText =
          seeMoreLink.getAttribute("data-closed-text");
        seeMoreLink.addEventListener("click", () => {
          text.classList.toggle("aur-truncated");
          if (text.classList.contains("aur-truncated")) {
            text.textContent = lastVisibleText + "...";
            seeMoreLink.textContent = seeMoreLinkClosedText;
            seeMoreLink.classList.remove("aur-see-more-open");
          } else {
            text.textContent = fullText;
            seeMoreLink.textContent = seeMoreLinkOpenText;
            seeMoreLink.classList.add("aur-see-more-open");
          }
        });
        text.setAttribute("data-full-text", fullText);
      } else {
        seeMoreLink.remove();
      }
    } else {
      const seeMoreLink = text.nextElementSibling;
      seeMoreLink.remove();
    }
  });

  //product view dropdown
  if (
    document.body.contains(
      document.querySelector(
        ".aur-section--product-category .aur-menu > li:has(ul) > a"
      )
    )
  ) {
    const product_view_button = document.querySelector(
      ".aur-section--product-category .aur-menu > li:has(ul) > a"
    );
    product_view_button_parent = product_view_button.parentElement;
    product_view_button.onclick = function () {
      window.event.preventDefault();
      product_view_button_parent.classList.toggle("aur-submenu-open");
    };
  }

  // //mobile menu toggle
  // if (document.body.contains(document.querySelector(".js-toggle-navigation"))) {
  //   const mobile_menu_button = document.querySelector(".js-toggle-navigation");
  //   mobile_menu_button.onclick = function () {
  //     console.log('clicked');
  //     this.classList.toggle("aur-navigation-is-open");
  //     document
  //       .querySelector(".aur-nav-wrapper")
  //       .classList.toggle("aur-navigation-is-open");
  //     document.querySelector(".aur-nav-wrapper").classList.add("transition");
  //     document
  //       .querySelector("body")
  //       .classList.toggle("aur-body-mobile-menu-open");

  //     window.scroll({
  //       top: 0,
  //       left: 0,
  //       behavior: "smooth",
  //     });
  //   };
  // }

  //mobile menu accordions
  const mobile_accordions = document.querySelectorAll(
    ".aur-site-header .aur-mid-header .aur-menu > li > ul > li:has(ul) > a"
  );

  for (let a = 0; a < mobile_accordions.length; a++) {
    const accordion_parent = mobile_accordions[a].parentElement;
    mobile_accordions[a].onclick = function () {
      window.event.preventDefault();
      this.parentElement.classList.toggle("aur-accordion-open");
    };
  }

  //.aur-faq-accordion-title
  const contact_tabs = document.querySelectorAll(".aur-faq-tab-title");
  const contact_tabs_content = document.querySelectorAll(".aur-faq-tab-item");

  for (let tb = 0; tb < contact_tabs.length; tb++) {
    contact_tabs[tb].onclick = function () {
      window.event.preventDefault();
      var tab_id = contact_tabs[tb].getAttribute("data-term");

      for (let ta = 0; ta < contact_tabs.length; ta++) {
        contact_tabs[ta].classList.remove("aur-tab-active");
      }

      this.classList.add("aur-tab-active");

      for (let tab = 0; tab < contact_tabs_content.length; tab++) {
        var tab_term = contact_tabs_content[tab].getAttribute("data-term");
        console.log(tab_id, tab_term, tb);
        if (tab_id == tab_term) {
          contact_tabs_content[tab].classList.add("aur-tab-active");
        } else {
          contact_tabs_content[tab].classList.remove("aur-tab-active");
        }
      }
    };
  }

  //contact accordions
  const contact_accordions = document.querySelectorAll(
    ".aur-faq-accordion-title"
  );

  for (let ca = 0; ca < contact_accordions.length; ca++) {
    const accordion_parent = contact_accordions[ca].parentElement;
    contact_accordions[ca].onclick = function () {
      window.event.preventDefault();
      this.parentElement.classList.toggle("aur-accordion-open");
    };
  }

  //similar products toggle .aur-reveal-similar-products
  const similar_products = document.querySelectorAll(
    ".aur-reveal-similar-products"
  );

  for (let a = 0; a < similar_products.length; a++) {
    const similar_products_parent = similar_products[a].parentElement;
    similar_products[a].onclick = function () {
      window.event.preventDefault();
      this.parentElement.classList.toggle("aur-similar-products-open");
    };
  }

  //side cart
  if (document.body.contains(document.querySelector(".aur-side-cart"))) {
    window.onscroll = function () {
      side_cart_layout();
    };

    side_cart_layout();

    function side_cart_layout() {
      const scroll_top = window.scrollY;
      const header_height =
        document.querySelector(".aur-site-header").offsetHeight;
      if (scroll_top > header_height) {
        document.querySelector(".aur-side-cart").style.height =
          "calc(100vh + 1px)";
      } else {
        const offset_height = header_height - scroll_top;
        document.querySelector(".aur-side-cart").style.height =
          "calc(100vh - " + offset_height + "px)";
      }
    }
  }

  if (document.body.contains(document.querySelector(".aur-side-cart"))) {
    const cart_button = document.querySelector(".aur-icon-nav-cart a");
    const cart_button_close = document.querySelector(".aur-side-cart-close");

    cart_button.onclick = function () {
      window.event.preventDefault();

      for (let e = 0; e < submenus.length; e++) {
        if (submenus[e].parentElement.classList.contains("aur-submenu-open")) {
          submenus[e].parentElement.classList.remove("aur-submenu-open");
        }
      }
      if (this.parentElement.classList.contains("aur-submenu-open")) {
        this.parentElement.classList.remove("aur-submenu-open");
        document
          .querySelector(".aur-side-cart-wrapper")
          .classList.remove("aur-side-cart-open");
        document
          .querySelector("body")
          .classList.remove("aur-body-submenu-open");
      } else {
        this.parentElement.classList.add("aur-submenu-open");
        document
          .querySelector(".aur-side-cart-wrapper")
          .classList.add("aur-side-cart-open");
        document.querySelector("body").classList.add("aur-body-submenu-open");
      }
    };

    cart_button_close.onclick = function () {
      cart_button.parentElement.classList.remove("aur-submenu-open");
      document
        .querySelector(".aur-side-cart-wrapper")
        .classList.remove("aur-side-cart-open");
      document.querySelector("body").classList.remove("aur-body-submenu-open");
    };
  }

  //create an account steps
  const steps = document.querySelectorAll(".aur-create-account-step--title");

  for (let s = 0; s < steps.length; s++) {
    const step_parent = steps[s].parentElement.parentElement;
    const step_title = steps[s];
    step_title.onclick = function () {
      if (step_parent.classList.contains("aur-account-step-active")) {
        step_parent.classList.remove("aur-account-step-active");
      } else {
        step_parent.classList.add("aur-account-step-active");
      }
    };
  }

  // aur-accordion-open

  //aur-product-accordion-item
  const product_accordions = document.querySelectorAll(
    ".aur-product-accordion-title"
  );

  for (let p = 0; p < product_accordions.length; p++) {
    const accordion_parent = product_accordions[p].parentElement;
    product_accordions[p].onclick = function () {
      window.event.preventDefault();
      this.parentElement.classList.toggle("aur-accordion-open");
    };
  }

  //dropdown menus
  const submenus = document.querySelectorAll(
    ".aur-site-header .aur-menu > li:has(ul) > a"
  );

  for (let e = 0; e < submenus.length; e++) {
    const submenu_parent = submenus[e].parentElement;
    const submenu_link = submenus[e];
    submenu_link.onclick = function () {
      if (this.parentElement.classList.contains("aur-submenu-open")) {
        closeSubmenu(this.parentElement);
      } else {
        openSubmenu(this.parentElement);
      }
    };
  }

  function openSubmenu(submenu_parent) {
    window.event.preventDefault();
    if (document.body.contains(document.querySelector(".aur-side-cart"))) {
      document
        .querySelector(".aur-icon-nav-cart")
        .classList.remove("aur-submenu-open");
      document
        .querySelector(".aur-side-cart-wrapper")
        .classList.remove("aur-side-cart-open");
    }

    for (let e = 0; e < submenus.length; e++) {
      if (submenus[e] != submenu_parent) {
        if (submenus[e].parentElement.classList.contains("aur-submenu-open")) {
          submenus[e].parentElement.classList.remove("aur-submenu-open");
        }
      }
    }

    submenu_parent.classList.add("aur-submenu-open");
    document.querySelector("body").classList.add("aur-body-submenu-open");
    //console.log('open sub');
  }

  function closeSubmenu(submenu_parent) {
    window.event.preventDefault();
    submenu_parent.classList.remove("aur-submenu-open");
    document.querySelector("body").classList.remove("aur-body-submenu-open");
    //console.log('close sub');
  }

  const closeSubmenuButtons = document.querySelectorAll(
    ".aur-dropdown-simple .aur-dropdown-close"
  );
  for (let e = 0; e < closeSubmenuButtons.length; e++) {
    closeSubmenuButtons[e].onclick = function () {
      //console.log(this.parentElement.parentElement);
      closeSubmenu(this.parentElement.parentElement.parentElement);
    };
  }

  document.querySelector("body").onclick = function (event) {
    //console.log(event.target);
    if (
      event.target.matches(
        ".aur-site-header .aur-menu, .aur-site-header .aur-menu *"
      )
    ) {
      if (event.target.matches(".aur-submenu-back > a")) {
        window.event.preventDefault();
        for (let e = 0; e < submenus.length; e++) {
          submenus[e].parentElement.classList.remove("aur-submenu-open");
        }
        document
          .querySelector("body")
          .classList.remove("aur-body-submenu-open");
      } else {
        return;
      }
    } else {
      for (let e = 0; e < submenus.length; e++) {
        submenus[e].parentElement.classList.remove("aur-submenu-open");
      }
      if (!event.target.matches(".aur-side-cart, .aur-side-cart *")) {
        if (document.body.contains(document.querySelector(".aur-side-cart"))) {
          const cart_button = document.querySelector(".aur-icon-nav-cart a");
          cart_button.parentElement.classList.remove("aur-submenu-open");
          document
            .querySelector(".aur-side-cart-wrapper")
            .classList.remove("aur-side-cart-open");
        }
        document
          .querySelector("body")
          .classList.remove("aur-body-submenu-open");
      }
    }

    if (
      document.querySelectorAll(
        ".aur-section--product-category .aur-menu > li:has(ul)"
      ).length
    ) {
      if (
        !event.target.matches(
          ".aur-section--product-category .aur-menu, .aur-section--product-category .aur-menu *"
        )
      ) {
        const product_view_button = document.querySelector(
          ".aur-section--product-category .aur-menu > li:has(ul) > a"
        );
        product_view_button_parent = product_view_button.parentElement;
        product_view_button_parent.classList.remove("aur-submenu-open");
      }
    }
  };

  //carousels
  const buttons = document.querySelectorAll(".aur-carousel-button");

  for (let i = 0; i < buttons.length; i++) {
    const list = buttons[i].parentElement.children[0];
    const item = buttons[i].parentElement.children[0].children[0];
    const direction = buttons[i].getAttribute("data-direction");
    buttons[i].onclick = function () {
      var itemWidth = item.offsetWidth + 24;
      handleClick(list, itemWidth, direction);
    };
  }

  function handleClick(list, itemWidth, direction) {
    const screenWidth = window.innerWidth;
    const listWidth = list.scrollWidth - screenWidth - itemWidth;

    if (direction === "previous") {
      list.scrollBy({ left: -itemWidth, behavior: "smooth" });
      if (list.scrollLeft == 0 || list.scrollLeft <= itemWidth) {
        //console.log('list start');
      }
    } else {
      //console.log('list: ', list.scrollLeft, listWidth);
      if (list.scrollLeft >= listWidth) {
        //console.log('list end');
      }
      list.scrollBy({ left: itemWidth, behavior: "smooth" });
    }
  }

  //product carousels
  const product_buttons = document.querySelectorAll(
    ".aur-product-image-slider-arrows .aur-product-image-slider-button"
  );

  for (let i = 0; i < product_buttons.length; i++) {
    const list = product_buttons[i].parentElement.parentElement.children[0];
    const item =
      product_buttons[i].parentElement.parentElement.children[0].children[0];
    const direction = product_buttons[i].getAttribute("data-direction");
    product_buttons[i].onclick = function () {
      var itemWidth = item.offsetWidth;
      handleClickProductSlider(list, itemWidth, direction);
    };
  }

  const product_thumbnails = document.querySelectorAll(
    ".aur-product-slider-thumbnails li a"
  );
  var product_thumbnail_index = 0;

  function handleClickProductSlider(list, itemWidth, direction) {
    const screenWidth = window.innerWidth;
    const listWidth = list.scrollWidth;
    if (direction === "previous") {
      list.scrollBy({ left: -itemWidth, behavior: "smooth" });
      if (product_thumbnail_index >= 1) {
        for (let g = 0; g < product_thumbnails.length; g++) {
          product_thumbnails[g].parentElement.classList.remove(
            "aur-slider-active"
          );
        }
        product_thumbnail_index = product_thumbnail_index - 1;
        product_thumbnails[product_thumbnail_index].parentElement.classList.add(
          "aur-slider-active"
        );
      }
    } else {
      list.scrollBy({ left: itemWidth, behavior: "smooth" });
      if (product_thumbnail_index < product_thumbnails.length - 1) {
        for (let g = 0; g < product_thumbnails.length; g++) {
          product_thumbnails[g].parentElement.classList.remove(
            "aur-slider-active"
          );
        }
        product_thumbnail_index = product_thumbnail_index + 1;
        product_thumbnails[product_thumbnail_index].parentElement.classList.add(
          "aur-slider-active"
        );
      }
      //console.log(product_thumbnail_index, product_thumbnails.length);
    }
  }

  for (let i = 0; i < product_thumbnails.length; i++) {
    product_thumbnails[i].onclick = function () {
      window.event.preventDefault();
      var button_index = this.getAttribute("data-index");
      var product_slider_href = this.getAttribute("href").substring(1);
      product_thumbnail_index = button_index - 1;
      document.getElementById(product_slider_href).scrollIntoView({
        behavior: "smooth",
        block: "nearest",
        inline: "center",
      });
      for (let e = 0; e < product_thumbnails.length; e++) {
        product_thumbnails[e].parentElement.classList.remove(
          "aur-slider-active"
        );
      }
      this.parentElement.classList.add("aur-slider-active");
    };
  }

  const range_sliders = document.querySelectorAll(
    '.aur-range-form-input-container span[contenteditable="true"]'
  );

  for (let r = 0; r < range_sliders.length; r++) {
    range_sliders[r].onkeypress = function (event) {
      if (
        (event.keyCode >= 48 && event.keyCode <= 57) ||
        event.keyCode === 13
      ) {
        return true;
      } else {
        return false;
      }
    };
  }

  /*  ==========================================================================
      First handoff completed - don't edit above this
  ============================================================================== */

  /*  ==========================================================================
      Changes after first handoff - add changes below this
  ============================================================================== */

  //mobile only sliders
  const mobile_slider_dots = document.querySelectorAll(
    ".aur-mobile-slider-dots li a"
  );
  var mobile_slider_index = 0;

  for (let m = 0; m < mobile_slider_dots.length; m++) {
    mobile_slider_dots[m].onclick = function (event) {
      var mobile_slider_href = this.getAttribute("href").substring(1);
      window.event.preventDefault();
      var context_mobile_slider_dot_list =
        this.parentElement.parentElement.parentElement;
      var context_mobile_slider_dots =
        context_mobile_slider_dot_list.querySelectorAll("li a");
      document.getElementById(mobile_slider_href).scrollIntoView({
        behavior: "smooth",
        block: "nearest",
        inline: "center",
      });
      for (let ms = 0; ms < context_mobile_slider_dots.length; ms++) {
        context_mobile_slider_dots[ms].parentElement.classList.remove(
          "aur-slider-active"
        );
      }
      this.parentElement.classList.add("aur-slider-active");
    };
  }

  const observer = new IntersectionObserver(
    (entries) => {
      if (!entries[0].isIntersecting) {
        //console.log('LEFT the screen ');
      } else {
        if (window.innerWidth < 640) {
          //console.log('ENTERED the screen');
          entries.forEach((elem) => {
            if (elem.isIntersecting) {
              const visible_slide_id = elem.target.getAttribute("id");
              console.log(elem.target.parentElement);
              var context_mobile_slider_dot_list =
                elem.target.parentElement.parentElement.querySelector(
                  ".aur-mobile-slider-dots"
                );
              var context_mobile_slider_dots =
                context_mobile_slider_dot_list.querySelectorAll("li a");
              for (let ms = 0; ms < context_mobile_slider_dots.length; ms++) {
                context_mobile_slider_dots[ms].parentElement.classList.remove(
                  "aur-slider-active"
                );
              }
              for (let msd = 0; msd < mobile_slider_dots.length; msd++) {
                var dot_slide_id = mobile_slider_dots[msd]
                  .getAttribute("href")
                  .substring(1);
                if (visible_slide_id == dot_slide_id) {
                  console.log("Visible: ", dot_slide_id);
                  document
                    .querySelector(
                      '.aur-mobile-slider-dots li a[href="#' +
                        dot_slide_id +
                        '"]'
                    )
                    .parentElement.classList.add("aur-slider-active");
                }
              }
            }
          });
        }
      }
    },
    { threshold: 1 }
  );

  document
    .querySelectorAll(".aur-is-mobile-slider > .aur-cell")
    .forEach((elem) => observer.observe(elem));

  //tooltips

  const tooltipTrigger = document.querySelectorAll(".aur-tooltip");

  for (let t = 0; t < tooltipTrigger.length; t++) {
    const tooltipExit =
      tooltipTrigger[t].parentElement.parentElement.children[1].children[0]
        .children[1];
    // console.log(tooltipTrigger[t]);

    tooltipTrigger[t].onclick = function () {
      const tooltipContentClose = document.querySelectorAll(
        ".aur-tooltip-content"
      );
      for (let tocl = 0; tocl < tooltipContentClose.length; tocl++) {
        tooltipContentClose[tocl].classList.remove("show");
      }

      const tooltipContent = this.parentElement.parentElement.children[1];
      tooltipContent.classList.add("show");
      console.log("open tooltip", tooltipContent);
    };

    tooltipExit.onclick = function () {
      const tooltipContent =
        tooltipTrigger[t].parentElement.parentElement.children[1];
      tooltipContent.classList.remove("show");
      console.log("close tooltip", tooltipContent);
    };
  }

  document.addEventListener("click", function (event) {
    const tooltipContent = document.querySelectorAll(".aur-tooltip-content");
    if (
      !event.target.closest(".aur-tooltip-container") &&
      !event.target.closest(".aur-tooltip")
    ) {
      for (let to = 0; to < tooltipContent.length; to++) {
        tooltipContent[to].classList.remove("show");
      }
    }
  });

  //price range slider

  function controlFromInput(fromSlider, fromInput, toInput, controlSlider) {
    const [from, to] = getParsed(fromInput, toInput);
    fillSlider(fromInput, toInput, "#C6C6C6", "#347FD8", controlSlider);
    fromInput.value = from;
    if (from > to) {
      fromSlider.value = to;
      fromInput.value = to;
    } else {
      fromSlider.value = from;
    }

    console.log("to max:", parseInt(toInput.max));
    if (from > parseInt(toInput.max)) {
      fromSlider.value = to;
      fromInput.value = to;
    }

    fromInput.style.width = fromInput.value.length + "ch";
  }

  function controlToInput(toSlider, fromInput, toInput, controlSlider) {
    const [from, to] = getParsed(fromInput, toInput);
    fillSlider(fromInput, toInput, "#C6C6C6", "#347FD8", controlSlider);
    setToggleAccessible(toInput);
    if (from <= to) {
      toSlider.value = to;
      toInput.value = to;
    } else {
      toInput.value = from;
      toSlider.value = from;
    }

    console.log(to, parseInt(toInput.max));
    if (to > parseInt(toInput.max)) {
      toSlider.value = toInput.max;
      toInput.value = toInput.max;
    }

    toInput.style.width = toInput.value.length + "ch";
  }

  function controlFromSlider(fromSlider, toSlider, fromInput) {
    const [from, to] = getParsed(fromSlider, toSlider);
    fillSlider(fromSlider, toSlider, "#C6C6C6", "#347FD8", toSlider);
    if (from > to) {
      fromSlider.value = to;
      fromInput.value = to;
    } else {
      fromInput.value = from;
    }
    fromInput.style.width = fromInput.value.length + "ch";
    console.log(fromInput.value.length);
  }

  function controlToSlider(fromSlider, toSlider, toInput) {
    toInput.style.width = toInput.value.length + "ch";
    const [from, to] = getParsed(fromSlider, toSlider);
    fillSlider(fromSlider, toSlider, "#C6C6C6", "#347FD8", toSlider);
    setToggleAccessible(toSlider);
    if (from <= to) {
      toSlider.value = to;
      toInput.value = to;
    } else {
      toInput.value = from;
      toSlider.value = from;
    }
    toInput.style.width = toInput.value.length + "ch";
  }

  function getParsed(currentFrom, currentTo) {
    if (currentFrom.value == "") {
      const to = parseInt(currentTo.value, 10);
      console.log(0, to);
      return [0, to];
    } else {
      // console.log(from, to);
      // return [from, to];
      const from = parseInt(currentFrom.value, 10);
      const to = parseInt(currentTo.value, 10);
      return [from, to];
    }

    // const from = parseInt(currentFrom.value, 10);
    // const to = parseInt(currentTo.value, 10);

    // if(from == NaN){
    //   console.log(0, to);
    //   return [0, to];
    // }else{
    //   console.log(from, to);
    //   return [from, to];
    // }
  }

  function fillSlider(from, to, sliderColor, rangeColor, controlSlider) {
    const rangeDistance = to.max - to.min;
    const fromPosition = from.value - to.min;
    const toPosition = to.value - to.min;
    controlSlider.style.background = `linear-gradient(
        to right,
        ${sliderColor} 0%,
        ${sliderColor} ${(fromPosition / rangeDistance) * 100}%,
        ${rangeColor} ${(fromPosition / rangeDistance) * 100}%,
        ${rangeColor} ${(toPosition / rangeDistance) * 100}%,
        ${sliderColor} ${(toPosition / rangeDistance) * 100}%,
        ${sliderColor} 100%)`;
  }

  function setToggleAccessible(currentTarget) {
    const toSlider = document.querySelector("#toSlider");
    if (Number(currentTarget.value) <= 0) {
      toSlider.style.zIndex = 2;
    } else {
      toSlider.style.zIndex = 0;
    }
  }

  // Function to get cookie by name
  function getCookie(name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(";").shift();
    return null;
  }

  // Function to set cookie
  function setCookie(name, value, days) {
    let expires = "";
    if (days) {
      const date = new Date();
      date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
      expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "") + expires + "; path=/";
  }

  // const fromSlider = document.querySelector('#fromSlider');
  // const toSlider = document.querySelector('#toSlider');
  // const fromInput = document.querySelector('#fromInput');
  // const toInput = document.querySelector('#toInput');

  // if(fromSlider !== null){
  //   fillSlider(fromSlider, toSlider, '#C6C6C6', '#347FD8', toSlider);
  //   setToggleAccessible(toSlider);

  //   fromSlider.oninput = () => controlFromSlider(fromSlider, toSlider, fromInput);
  //   toSlider.oninput = () => controlToSlider(fromSlider, toSlider, toInput);
  //   fromInput.oninput = () => controlFromInput(fromSlider, fromInput, toInput, toSlider);
  //   toInput.oninput = () => controlToInput(toSlider, fromInput, toInput, toSlider);

  //   controlToInput(toSlider, fromInput, toInput, toSlider);
  //   controlFromInput(fromSlider, fromInput, toInput, toSlider);

  // }

  //end of DOMContentLoaded function

  // const prescriptionModalActive = "aur-submenu-open";
  // const prescriptionModal = document.querySelector(
  //   ".aur-icon-nav-prescriptions"
  // );

  // if (!getCookie("prescription-active") && prescriptionModal) {
  //   prescriptionModal.classList.add(prescriptionModalActive);
  // }

  // if ( document.querySelector(".close-prescription-modal") ) {
  //   document.querySelector(".close-prescription-modal").onclick = function () {
  //     if (!getCookie("prescription-active")) {
  //       setCookie("prescription-active", "true", 30);
  //     }
  //     prescriptionModal.classList.remove(prescriptionModalActive);
  //   };
  // }

});
